import DisableEmptyLink from "./features/disableEmptyLink";
import StickyNavbar from "./features/stickyNavbar";
import Toggler from "./features/toggler";
import ScrollBackTop from "./features/scrollBackTop";
import Tooltip from "./features/tooltip";
import "./lazysizes";
import "./features/switch-darkmode";

class Theme {
  constructor() {

    this.features = [
      new DisableEmptyLink(),
      new StickyNavbar(),
      new Toggler('[data-toggle="offcanvas"]', '.offcanvas-close', '.offcanvas-container'),
      new Toggler( '[data-toggle="fullscreen-overlay"]', '.fs-overlay-close', '.fs-overlay-wrapper'),
      new ScrollBackTop(),
      new Tooltip(),
    ];

    this.features.forEach(feature => {
      try {
        feature.enable();
      }
      catch (e) {
        console.log(e.message);
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.imaios_theme = new Theme();

  const mdBreakpoint = getMdBreakpoint();

  const mobileMenuBackdrop = document.getElementById('mobile-menu-backdrop');
  const mobileMenu = document.getElementById('mobile-menu');
  const mobileMenuBurger = document.getElementById('mobile-menu-burger');

  const myAccountMobileMenuBtn = document.getElementById('myaccount-mobile-menu-btn');
  const myAccountMobileMenu = document.getElementById('myaccount-mobile-menu-panel');
  const myAccountMobileMenuBack = document.getElementById('myaccount-mobile-menu-back');

  if (!mobileMenuBackdrop || !mobileMenu) {
    return;
  }
  mobileMenuBackdrop?.addEventListener('click', closeMobileMenu);
  window.addEventListener('resize', removeMobileMenuOnDesktop);

  mobileMenuBurger?.addEventListener('click',() => {
    mobileMenu?.classList.remove('invisible');
    mobileMenuBackdrop?.classList.remove('d-none');
  });

  mobileMenu?.addEventListener('transitionend', () => {
    if (!mobileMenu.classList.contains('in-view')) {
      document.body.style.removeProperty('overflow');
      document.getElementById('mobile-menu-backdrop')?.classList.add('d-none');
      // wait half a second so all transitions are settled,
      // we could track if there's active transition, but it's simpler that way
      setTimeout(() => {
        mobileMenu.classList.add('invisible');
      }, 500);
    }
    else {
      document.body.style.setProperty('overflow', 'hidden');
    }
  });
  mobileMenu?.addEventListener('transitionstart', () => {
    if (mobileMenu.classList.contains('in-view')) {
      mobileMenu.classList.remove('invisible');
    }
  });

  myAccountMobileMenuBtn.addEventListener('click', () => {
    myAccountMobileMenu.classList.add('in-view');
    myAccountMobileMenu.classList.remove('d-none');
  })

  myAccountMobileMenuBack.addEventListener('click', () => {
    myAccountMobileMenu.classList.remove('in-view');
  })


  function closeMobileMenu() {
    mobileMenuBackdrop?.classList.add('d-none');
    myAccountMobileMenu?.classList.add('d-none');
    myAccountMobileMenu?.classList.remove('in-view');
    mobileMenu?.classList.remove('in-view');

  }
  function removeMobileMenuOnDesktop() {
    if (window.innerWidth >= mdBreakpoint) {
      closeMobileMenu();
    }
  }

});
window.onload = function(){
  const imgLazyLoad = document.querySelectorAll('.lazyload');
  imgLazyLoad.forEach(function (elem) {
    elem.classList.remove('lazyload');
  });
};

function getMdBreakpoint() {
  const mdBreakpoint = getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-md');

  if (!mdBreakpoint) {
    return 768;
  }

  return parseInt(mdBreakpoint);

}
